import { HttpResult } from 'widgets-for-react'
import { SpecialistPageData } from '../../../sharepointPageApi/types/pageData'
import { SpecialistPage } from '../../../cmsPageState'
import { transformSpecialistPageData } from '../../../sharepointPageApi/transformers/pageDataToPage'
import { PageInfo } from '../../../sharepointPageApi/types/blockData'

export const specialistsBlockApi = async (pageInfo?: PageInfo): Promise<HttpResult<SpecialistPage[]>> => {
  const endpoint = `/api/v1/pages/specialists/random?count=6${
    pageInfo?.department ? `&department=${encodeURIComponent(pageInfo.department)}` : ''
  }${
    pageInfo?.subdepartment ? `&subdepartment=${encodeURIComponent(pageInfo.subdepartment)}` : ''
  }${
    pageInfo?.centrum ? `&centrum=${encodeURIComponent(pageInfo.centrum)}` : ''
  }${
    pageInfo?.subcentra ? `&subcentra=${encodeURIComponent(pageInfo.subcentra)}` : ''
  }`

  const res = await fetch(endpoint)
  if (!res.ok) {
    return {
      kind: 'failed',
      status: res.status,
    }
  }

  const data: SpecialistPageData[] = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: data.map((item) => transformSpecialistPageData(item)),
  }
}
